import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "variant", "size", "loading", "loadingAriaLabel", "aria-label"];
import { jsx, jsxs } from 'react/jsx-runtime';
import { Button } from '@ariakit/react';
import clsx from 'clsx';
import { forwardRef, useRef, useMemo, Children, isValidElement } from 'react';
import { LoadingIndicator } from '../../loading-indicator/loading-indicator.js';
import { getButtonOptions } from '../../utils/getButtonOptions.js';
import { useForkRef } from '../../utils/useForkRef.js';
import { BaseButtonContext } from './base-button-context.js';
import { BaseButtonIcon } from './base-button-icon.js';
import styles from './base-button.module.js';
import { loadingIndicatorVariantMap } from './utils.js';
var BaseButton = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _clsx;

  var _getButtonOptions = getButtonOptions(props),
      children = _getButtonOptions.children,
      className = _getButtonOptions.className,
      _getButtonOptions$var = _getButtonOptions.variant,
      variant = _getButtonOptions$var === void 0 ? 'primary' : _getButtonOptions$var,
      _getButtonOptions$siz = _getButtonOptions.size,
      size = _getButtonOptions$siz === void 0 ? 'small' : _getButtonOptions$siz,
      loading = _getButtonOptions.loading,
      loadingAriaLabel = _getButtonOptions.loadingAriaLabel,
      ariaLabel = _getButtonOptions['aria-label'],
      rest = _objectWithoutProperties(_getButtonOptions, _excluded);

  var ref = useRef(null);
  var isIconButton = useMemo(function () {
    var childArray = Children.toArray(children);
    var firstChild = childArray[0];
    return childArray.length === 1 && /*#__PURE__*/isValidElement(firstChild) && firstChild.type === BaseButtonIcon;
  }, [children]);
  var context = useMemo(function () {
    return {
      ariaLabel: ariaLabel,
      loading: loading,
      size: size,
      variant: variant,
      isIconButton: isIconButton
    };
  }, [ariaLabel, loading, size, variant, isIconButton]);
  return jsx(Button, _objectSpread(_objectSpread({}, rest), {}, {
    ref: useForkRef(ref, forwardedRef),
    "aria-label": loading ? undefined : ariaLabel,
    className: clsx([styles.button, styles[variant], styles[size]], (_clsx = {}, _defineProperty(_clsx, styles.isIconButton, isIconButton), _defineProperty(_clsx, styles.hide, loading), _clsx), className),
    children: jsxs(BaseButtonContext.Provider, {
      value: context,
      children: [children, loading && loadingAriaLabel ? jsx(LoadingIndicator, {
        "aria-label": loadingAriaLabel,
        variant: loadingIndicatorVariantMap[variant]
      }) : null]
    })
  }));
});
export { BaseButton };